module.exports = __webpack_public_path__ + "img/thumbnail_AfricanBuffalo_j_albino.6ff52e26.png";